// import Swiper JS and style
import Swiper from 'swiper'
import { Keyboard, Navigation } from 'swiper/modules'
import documentReady from '../common/documentReady.ts'

Swiper.use([Keyboard, Navigation])

function initSwipers () {
  const swipers = document.getElementsByClassName('swiper-inner')
  for (const swiper of swipers) {
    // eslint-disable-next-line no-unused-vars
    const s = new Swiper(`#${swiper.id}`, {
      slidesPerView: 2,
      spaceBetween: 2,
      keyboard: {
        enabled: true
      },
      navigation: {
        nextEl: `.swiper-container .right-${swiper.id}`,
        prevEl: `.swiper-container .left-${swiper.id}`
      },
      breakpoints: {
        850: {
          slidesPerView: 4
        }
      }
    })
  }
}

documentReady(initSwipers)
